type PageToolbarProps = {
  left?: React.ReactNode;
  right?: React.ReactNode;
};

/**
 * The single page-level toolbar. Renders a `justify-between` flex bar with two
 * slots; either may be omitted (an empty `left` collapses to right-aligned).
 * Inner slot styling owns the gap between controls so the controls inside each
 * slot stay in lockstep across every consumer.
 */
export function PageToolbar({ left, right }: PageToolbarProps) {
  return (
    <div className="flex flex-row flex-wrap gap-4 px-4 py-3 items-center justify-between">
      <div className="flex flex-row gap-4 items-center">{left}</div>
      <div className="flex flex-1 flex-row gap-4 items-center justify-end">{right}</div>
    </div>
  );
}
